// extracted by mini-css-extract-plugin
module.exports = {"gallery":"photography-module--gallery--3aRpp","shadow":"photography-module--shadow--2LeBz","buttons":"photography-module--buttons--M3o_y"};